export default "__VITE_ASSET__5ffb7b70__"